import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTRSNode } from 'API/TRSNodes/deleteTRSNode';

const useDeleteTRSNode = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const deleteNodeMutation = async (nodeId) => {
        try {
            const response = await deleteTRSNode(nodeId);
            return response.data;
        } catch (error) {
            console.error('Error deleting TRS node:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteNodeMutation,
        onSuccess: (data, nodeId) => {
            // Invalidate and refetch the nodes list
            queryClient.invalidateQueries({ queryKey: ['TRSNodes'] });
            // Remove the specific node from cache
            queryClient.removeQueries({ queryKey: ['TRSNode', nodeId] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteTRSNode;
